export default __webpack_public_path__ + "static/media/macos.b7f5324b.svg";